import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { dealStatuses } from '../../constants';
import {
  unmatchDeal,
  viewProposal,
  escrowFunds,
  openCompleteDealForm,
  openReviewContentView,
  archiveDeal,
  completeContent
} from '../../store/actions/dealActions';
import { openEscrowView } from '../../store/actions/paymentsActions';
import {
  primary,
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../style';
import { getDealList } from '../../store/selectors/deals';
import { addRating } from '../../store/actions/ratingActions';
import {
  getCampaignsCount,
  getCampaignsLoaded
} from '../../store/selectors/campaigns';

const styles = theme => ({
  root: {
    width: '100%',
    marginBottom: '30px',
    minHeight: '150px',
    position: 'relative'
  },
  layout: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  descriptionContainer: {
    marginTop: '30px',
    maxHeight: '100px',
    overflow: 'hidden'
  },
  tableCell: {
    paddingTop: '30px',
    paddingBottom: '30px'
  },
  companyImage: {
    height: '70px',
    borderRadius: '100px'
  },
  icon: {
    color: 'red',
    width: '25px',
    height: '25px'
  },
  title: {
    marginBottom: '30px',
    color: deepPurple
  },
  matchedStatus: {
    color: 'green'
  },
  tableRow: {
    cursor: 'pointer'
  },
  acceptButton: {
    minWidth: 150,
    padding: 'auto 20px',
    display: 'inline-block',
    color: white
  },
  unmatchButton: {
    minWidth: 150,
    padding: 'auto 20px',
    display: 'inline-block'
  },
  text: {
    minWidth: 150,
    textAlign: 'center'
  },
  rejectButton: {
    width: '150px',
    display: 'block',
    marginTop: '20px'
  },
  select: {
    marginBottom: '50px',
    width: '250px',
    marginTop: '0px',
    background: white,
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  dealWrapper: {
    minWidth: '100%',
    margin: -10,
    '& > *': {
      display: 'inline-block',
      padding: 10
    }
  },
  status: {
    wordBreak: 'break-all'
  },
  displayName: {
    width: 'calc(15% - 17.5px)',
    alignItems: 'center',
    '& > *': {
      wordBreak: 'break-all'
    }
  },
  link: {
    width: 'calc(40% - 17.5px)',
    alignItems: 'center',
    '& > *': {
      wordBreak: 'break-all'
    }
  },
  accept: {
    width: 'calc(30% - 17.5px)',
    alignItems: 'center'
  },
  viewDealButton: {
    float: 'right',
    width: '60px',
    marginLeft: '10px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignContent: 'center',
    height: '100%',
    backgroundColor: primary,
    position: 'absolute',
    color: 'white',
    cursor: 'pointer'
  },
  dealContainer: {
    display: 'inline-block',
    width: 'calc(100% - 70px)',
    paddingLeft: '30px',
    paddingTop: '30px',
    paddingBottom: '30px',
    height: '100%'
  },
  viewDealIcon: {
    alignSelf: 'center',
    fontSize: '2em'
  },
  noCurrentDeals: {
    height: '150px'
  },
  noDealsContainer: {
    marginTop: '55px'
  },
  ratingContainer: {
    textAlign: 'center'
  },
  archiveLink: {
    marginTop: '20px',
    color: '#22c26e'
  },
  createCampLink: {
    color: '#22c26e',
    display: 'inline',
    fontSize: '1em'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '96px',
    height: '96px'
  },
  messageText: {
    fontSize: '.8em'
  },
  acceptButtonContainer: {
    marginTop: '30px'
  },
  acceptSubmitButton: {
    float: 'right',
    color: 'white'
  },
  warningIcon: {
    width: '15px',
    color: 'red'
  },
  spinnerContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    // display: 'flex',
    // alignItems: 'center',
    // justifyItems: 'center',
    background: 'white',
    zIndex: '999',
    opacity: '.5'
  },
  downArrow: {
    position: 'fixed',
    left: '50%',
    top: '50%',
    zIndex: '1000'
    // display: 'block',
    // margin: '0 auto'
  },
  dealForm: {
    marginTop: '25px'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    dealList: getDealList(state),
    campaignsCount: getCampaignsCount(state),
    campaignsLoaded: getCampaignsLoaded(state),
    isCompany: state.firebase.profile.isCompany,
    escrowReleaseIsProcessing: state.payments.escrowReleaseIsProcessing,
    acceptDealInProgress: state.dealState.acceptingDealInProgress
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    unmatchDealClick: (dealId, updaterId) =>
      dispatch(unmatchDeal(dealId, updaterId)),
    viewProposalClick: deal => dispatch(viewProposal(deal)),
    viewEscrowFundsClick: deal => dispatch(openEscrowView(deal)),
    viewCompleteDealFormClick: deal => dispatch(openCompleteDealForm(deal)),
    handleReviewContentClick: deal => dispatch(openReviewContentView(deal)),
    archiveDealHandler: (dealId, isCompany) =>
      dispatch(archiveDeal(dealId, isCompany)),
    addRatingHandler: (dealId, rater, ratedUser, rating) =>
      dispatch(addRating(dealId, rater, ratedUser, rating)),
    completeContentHandler: (dealId, userId) =>
      dispatch(completeContent(dealId, userId))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withFirestore,
  withStyles(styles),
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/deals/Deals.enhancer.js